import React from 'react';
import ExerciseResults from '../shared/ExerciseResults';

const FillInResults = ({ questions, userAnswers, restart, onBack, engagementData, engagementLoading }) => {
  // Calculate score
  const correctAnswers = questions.filter(q =>
    userAnswers[q.id] === q.answer
  ).length;

  const totalQuestions = questions.length;

  return (
    <ExerciseResults
      title="Výsledky - Doplnovani"
      score={correctAnswers}
      total={totalQuestions}
      color="blue"
      onRestart={restart}
      onBack={onBack}
      engagementData={engagementData}
      engagementLoading={engagementLoading}
    >
      {/* Detailed Results */}
      <h3 className="text-lg font-semibold text-gray-800 mb-4">
        Detailní výsledky
      </h3>

      <div className="flex flex-col gap-3">
        {questions.map((question, index) => {
          const userAnswer = userAnswers[question.id];
          const isCorrect = userAnswer === question.answer;
          const parts = question.partial_answer.split('____');

          return (
            <div
              key={question.id}
              className={`p-4 rounded-lg ${
                isCorrect
                  ? 'bg-green-50'
                  : 'bg-red-50'
              }`}
            >
              <div className="flex items-start gap-3">
                <span className="text-blue-600 font-semibold min-w-[30px]">
                  #{index + 1}
                </span>
                <div className="flex-1">
                  <div className="text-sm text-gray-600 mb-2">
                    <strong>Otazka:</strong> {question.question}
                  </div>
                  <div className="text-gray-800 mb-2">
                    {parts[0]}
                    <strong className={`${
                      isCorrect
                        ? 'text-green-600'
                        : 'text-red-500 line-through'
                    }`}>
                      {userAnswer || '(nevyplneno)'}
                    </strong>
                    {parts[1] && parts[1]}
                  </div>
                  {!isCorrect && (
                    <div className="text-sm text-gray-600">
                      <strong>Správná odpověd:</strong> {parts[0]}
                      <strong className="text-green-600">{question.answer}</strong>
                      {parts[1] && parts[1]}
                    </div>
                  )}
                  <div className={`text-sm font-medium mt-2 ${
                    isCorrect ? 'text-green-600' : 'text-red-500'
                  }`}>
                    {isCorrect ? '✓ Správně' : '✗ Špatně'}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </ExerciseResults>
  );
};

export default FillInResults;
